import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const generateQuery = async (payload) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(`${__API_URL__}/api/ecrf/generate_query/`, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGenerateQueryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: generateQuery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["query_logs"] });
    },
  });
};

export default useGenerateQueryMutation;
